export const otherAttributes = [
  { title: 'Mobile', value: 'mobile', type: 'phoneNumber' },
  { title: 'Home', value: 'home', type: 'phoneNumber' },
  { title: 'Company', value: 'company', type: 'company' },
  { title: 'Work', value: 'work', type: 'phoneNumber' },
  { title: 'Notes', value: 'note', type: 'paragraph' },
];

const contactList = JSON.parse(
  `[{
    "id": 22143,
    "avatar": "https://randomuser.me/api/portraits/men/46.jpg",
    "firstName": "Benjamin",
    "lastName": "Jacobi",
    "name": "Benjamin Jacobi",
    "mobile": "(023) 302-3161 x60451",
    "home": "(136) 403-0476 x8388",
    "company": "Casper Inc",
    "work": "(399) 506-9438",
    "note": "Quisquam et nisi. Dicta in ut eos consequatur ipsum omnis. Quisquam doloremque error praesentium sapiente et vitae. Omnis facere sint nulla similique vel voluptatem officia deleniti."
  }, {
    "id": 17385,
    "avatar": "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-0.3.5&q=80&fm=jpg&crop=faces&fit=crop&h=200&w=200&s=046c29138c1335ef8edee7daf521ba50",
    "firstName": "Clementina",
    "lastName": "Hahn",
    "name": "Clementina Hahn",
    "mobile": "686.292.3548 x7219",
    "home": "447-343-4864 x414",
    "company": "Marquardt Inc",
    "work": "299-721-6828 x856",
    "note": "Distinctio voluptas repellendus rerum temporibus deserunt et corrupti sint. Odit sit labore quia. Perferendis iure eos qui tempore ex saepe consequuntur accusamus ipsa. Eius consectetur nam quas. Laborum aperiam hic dolorum quae autem consequatur."
  }, {
    "id": 85838,
    "avatar": "https://images.unsplash.com/photo-1498529605908-f357a9af7bf5?ixlib=rb-0.3.5&q=80&fm=jpg&crop=faces&fit=crop&h=200&w=200&s=047fade70e80ebb22ac8f09c04872c40",
    "firstName": "Clinton",
    "lastName": "Goyette",
    "name": "Clinton Goyette",
    "mobile": "(913) 127-1563 x082",
    "home": "(843) 501-8804",
    "company": "Feil - Goodwin",
    "work": "732.111.8883",
    "note": "Maiores animi et quidem. Ducimus voluptate est consequatur ut vitae in. Ut fugit sit ab blanditiis ab occaecati soluta quis."
  }, {
    "id": 2791,
    "avatar": "https://images.unsplash.com/photo-1506803682981-6e718a9dd3ee?ixlib=rb-0.3.5&q=80&fm=jpg&crop=faces&fit=crop&h=200&w=200&s=c3a31eeb7efb4d533647e3cad1de9257",
    "firstName": "Forrest",
    "lastName": "Klein",
    "name": "Forrest Klein",
    "mobile": "174-628-5802 x8324",
    "home": "(047) 141-0247",
    "company": "Wilkinson - Howe",
    "work": "1-624-238-9252",
    "note": "Sit et non debitis. Quis atque facilis et sed. Illum adipisci deserunt corporis modi necessitatibus at numquam neque sint."
  }, {
    "id": 67493,
    "avatar": "https://images.unsplash.com/photo-1476900966873-ab290e38e3f7?ixlib=rb-0.3.5&q=80&fm=jpg&crop=faces&fit=crop&h=200&w=200&s=fe0976a79ece0ee8effca4cab4527ae2",
    "firstName": "General",
    "lastName": "Kub",
    "name": "General Kub",
    "mobile": "779.482.9824",
    "home": "(698) 858-0337 x3273",
    "company": "Moen Group",
    "work": "881.768.7522",
    "note": "Quibusdam dolorem minima ea enim nostrum eos. Corrupti dolore velit molestiae nostrum error qui. Sit qui maxime sed quisquam rem cupiditate. Iste ex quidem. Ipsam et quia omnis facere blanditiis."
  }, {
    "id": 75593,
    "avatar": "https://images.unsplash.com/photo-1505196298139-8cfce5efd3d7?ixlib=rb-0.3.5&q=80&fm=jpg&crop=faces&fit=crop&h=200&w=200&s=086d0c442db382f3faadb8156eecafa7",
    "firstName": "Lon",
    "lastName": "Wunsch",
    "name": "Lon Wunsch",
    "mobile": "(792) 607-6366 x88975",
    "home": "447.683.3799 x38668",
    "company": "Johns, Gibson and Schinner",
    "work": "(735) 859-7674",
    "note": "Velit non voluptas sed sit pariatur earum unde neque. Incidunt nam reprehenderit non mollitia. Incidunt quo illum modi ex eos consequuntur eius nihil itaque. Quis tenetur ratione repudiandae ea et architecto dolorem porro. Rem non consectetur ea iste."
  }, {
    "id": 90096,
    "avatar": "https://images.unsplash.com/photo-1503467913725-8484b65b0715?ixlib=rb-0.3.5&q=80&fm=jpg&crop=faces&fit=crop&h=200&w=200&s=cf7f82093012c4789841f570933f88e3",
    "firstName": "Mabelle",
    "lastName": "Kling",
    "name": "Mabelle Kling",
    "mobile": "499-736-0779 x2409",
    "home": "1-910-529-7393 x222",
    "company": "Bins, Murray and Ryan",
    "work": "905.098.6372",
    "note": "Et et rerum placeat beatae doloribus earum et reiciendis. Nisi suscipit ad dolor. Tenetur hic quia nihil deleniti inventore. Blanditiis aliquam ea ea. Omnis consequatur itaque est rerum sed reiciendis laboriosam reiciendis. Consectetur ullam et laudantium at itaque aut qui et molestiae."
  }, {
    "id": 15783,
    "avatar": "https://images.unsplash.com/photo-1509380836717-c4320ccf1a6f?ixlib=rb-0.3.5&q=80&fm=jpg&crop=faces&fit=crop&h=200&w=200&s=e01c8c45a063daaf6d6e571a32bd6c90",
    "firstName": "Maryse",
    "lastName": "Koss",
    "name": "Maryse Koss",
    "mobile": "668-920-9662 x610",
    "home": "075.864.1819 x8265",
    "company": "Smitham Inc",
    "work": "468.534.0931",
    "note": "Libero perferendis aut repudiandae quas. Omnis aut enim voluptas magnam harum quisquam illo aliquid aliquam. Dolor et et vel nihil quibusdam fugit facere adipisci aut. Repellat quia est beatae animi ipsa. Ad sit eligendi pariatur quia illo atque qui voluptatem excepturi."
  }, {
    "id": 42122,
    "avatar": "https://images.unsplash.com/photo-1549068106-b024baf5062d?ixlib=rb-1.2.1&q=80&fm=jpg&crop=faces&fit=crop&h=200&w=200&ixid=eyJhcHBfaWQiOjE3Nzg0fQ",
    "firstName": "Maude",
    "lastName": "Grant",
    "name": "Maude Grant",
    "mobile": "1-077-505-0657",
    "home": "062.968.4841 x62748",
    "company": "Thiel, Bauch and Mosciski",
    "work": "1-318-593-2619 x206",
    "note": "Ut sit fuga quibusdam. Ullam non necessitatibus voluptatem quidem est dignissimos dolores quaerat. Aspernatur fugiat et."
  }, {
    "id": 5869,
    "avatar": "https://images.unsplash.com/photo-1502937406922-305bb2789e95?ixlib=rb-0.3.5&q=80&fm=jpg&crop=faces&fit=crop&h=200&w=200&s=9ccf7504e3c56169185184198f642dcf",
    "firstName": "Orrin",
    "lastName": "Harris",
    "name": "Orrin Harris",
    "mobile": "871.567.4877",
    "home": "(466) 574-3352",
    "company": "Haag Group",
    "work": "1-908-422-4964",
    "note": "Aut sequi quae omnis ut qui quaerat. Dolor et fugit blanditiis laudantium. Libero modi officiis consequatur corrupti reiciendis aut qui nemo doloribus. Consequatur voluptatibus quis vero numquam aspernatur a sit laborum voluptates."
  }]`
);

export default class fakeData {
  constructor(size = 10) {
    this.size = size;
    this.datas = [];
  }
  dataModel(index) {
    return contactList[index];
  }
  getObjectAt(index) {
    if (index < 0 || index > this.size) {
      return undefined;
    }
    if (this.datas[index] === undefined) {
      this.datas[index] = this.dataModel(index);
    }
    return this.datas[index];
  }
  getAll() {
    if (this.datas.length < this.size) {
      for (let i = 0; i < this.size; i++) {
        this.getObjectAt(i);
      }
    }
    return this.datas
      .slice()
      .sort(
        (contact1, contact2) =>
          `${contact1.firstName}${contact1.LastName}`.toUpperCase() >
          `${contact2.firstName}${contact2.LastName}`.toUpperCase()
      );
  }

  getSize() {
    return this.size;
  }
}
